import React, { useMemo } from "react";
import { useAppSelector } from "../../../app/store";
import { ADMIN_LANG } from "../../../settings";
import {Col} from "react-bootstrap";

const QuestionBasicDetails = React.memo(() => {
    const {
        title,
        played,
        average_points,
        max_points,
        type_display,
        game,
        right_answers,
        wrong_answers,
    } = useAppSelector((state) => state.adminQuestion);

    const gameUrl = game ? `/admin/games/${game.game_id}/versions/${game.version_id}/` : '';

    const { rightPercent, wrongPercent } = useMemo(() => {
        const right = played > 0 ? (right_answers / played) * 100 : 0;
        const wrong = played > 0 ? (wrong_answers / played) * 100 : 0;
        return {
            rightPercent: right.toFixed(0),
            wrongPercent: wrong.toFixed(0),
        };
    }, [right_answers, wrong_answers, played]);

    return (
        <Col xs={12}>
            <div className='admin-card'>
                <h2>
                    {title}
                </h2>
                {game && (
                    <h3>
                        <span> {ADMIN_LANG.game}: </span>
                        <a href={gameUrl}>{game.name}</a>
                    </h3>
                )}
                <div className='small-p-margin'>
                    <p><strong>{ADMIN_LANG.question_type}:</strong> {type_display}</p>
                    <p><strong>{ADMIN_LANG.played}:</strong> {played} {ADMIN_LANG.times}</p>
                    {average_points !== null && average_points !== undefined && average_points !== 0 && (
                      <p><strong>{ADMIN_LANG.average_points}:</strong> {average_points}</p>
                    )}
                    {max_points > 0 && <p><strong>{ADMIN_LANG.max_points}:</strong> {max_points}</p>}
                    <p><strong>{ADMIN_LANG.right_answers}: </strong>
                        <span className='text-success'>
                        {right_answers} ({rightPercent}%)
                    </span></p>
                    <p><strong>{ADMIN_LANG.wrong_answers}: </strong>
                        <span className='text-danger'>
                        {wrong_answers} ({wrongPercent}%)
                    </span></p>
                </div>
            </div>
        </Col>
    );
});

export default QuestionBasicDetails;